import mapConversationTypeToConversationItem from '../../store-factory/mapConversationTypeToConversationItem';
import mapConversationTypeToConversationRelation from '../../store-factory/mapConversationTypeToConversationRelation';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getTableToRowRelationKey from 'owa-mail-list-store/lib/utils/getTableToRowRelationKey';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Adds or updated the conversation in the tableView, tableViewConversationRelations
 * This is called whenever a data is fetched from the server and is being stored. This is also called when
 * a rowAdd or rowModified notificaiton occurs
 * @param conversation to add or update
 * @param tableId where to add or update the conversation
 * @param state for unit testing
 */
export default select({
    conversationItems: function () { return listViewStore.conversationItems; },
    tableViewConversationRelations: function () { return listViewStore.tableViewConversationRelations; },
})(action('addOrUpdateConversationData')(function addOrUpdateConversationData(conversation, tableView, state) {
    var conversationItems = state.conversationItems, tableViewConversationRelations = state.tableViewConversationRelations;
    var conversationId = conversation.ConversationId.Id;
    var tableConversationRelationKey = getTableToRowRelationKey(conversation.InstanceKey, tableView.id);
    var conversationItem = mapConversationTypeToConversationItem(conversation, tableView);
    conversationItems.set(conversationId, conversationItem);
    // Create or update the relation object
    var newRelation = mapConversationTypeToConversationRelation(conversation);
    tableViewConversationRelations.set(tableConversationRelationKey, newRelation);
}));
//# sourceMappingURL=addOrUpdateConversationData.js.map